"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myObject = void 0;
var toUpperCase_1 = require("./tools/toUpperCase");
exports.myObject = { "p": toUpperCase_1.toUpperCase("foo") };
//# sourceMappingURL=myObject.js.map